import { useContext } from "react";
import AuthContext from "../context/Authentication/AuthContext";

export default function useClient() {
  const auth = useContext(AuthContext);
  return auth.client;
}
